import { FunctionalComponent } from 'preact'
import UserAvatar from '../User/UserAvatar'
import getServerData from '../../services/featuredTopicsData'
import { FeaturedTopic, FeaturedEvent } from '../widget-featured-topics/types'
import { FeaturedTopicFromUnified } from '../../services/unified'
import { GetServerSideProps } from '../../server-middleware/context'
import { z } from 'zod'
import DateRelative from '../../libs/translationsUtils/dateRelative'
import EventDateFormatter from '../event/EventDateFormatter'

interface TopicBannerData {
  author?: {
    url: string
    name: string
    avatar: string
  }
  post?: {
    author: {
      url: string
      name: string
      avatar: string
    }
    relativeCreationDate: string
  }
  createdAt?: string
  startsAt?: number
  publishedAt?: string
  url: string
  title: string
}

interface Props {
  selectedTopic: TopicBannerData | null
}

function isEvent (topic: FeaturedTopic|FeaturedTopicFromUnified|FeaturedEvent): topic is FeaturedEvent {
  return topic.contentType === 'event'
}

export const widgetName = 'topic_banner'

export const config = z.object({
  selectedTopic: z.object({
    id: z.string(),
    type: z.string()
  }).or(z.null()).default(null)
}).default({
  selectedTopic: null
})

type ConfigType = z.infer<typeof config>

export const getServerSideProps: GetServerSideProps<ConfigType, Props> = async (context, config) => {
  if (!config.selectedTopic) return { selectedTopic: null }
  const topics = await context.cache(`topic-banner-${JSON.stringify(config)}-${context.userId}`, async () => await getServerData(context, config.selectedTopic ? [config.selectedTopic] : []), 60)

  const selectedTopic = topics[0]
  if (!selectedTopic) {
    return {
      selectedTopic: null
    }
  }

  if (isEvent(selectedTopic)) {
    return {
      selectedTopic: {
        url: `/events/${config.selectedTopic.id}`,
        title: selectedTopic.title,
        createdAt: selectedTopic.lastActivityAt,
        publishedAt: selectedTopic.lastActivityAt,
        startsAt: selectedTopic.startsAt,
        author: undefined
      }
    }
  }

  return { selectedTopic }
}

const TopicBanner: FunctionalComponent<Props> = ({ selectedTopic }: Props) => {
  if (!selectedTopic) {
    return null
  }

  const author = selectedTopic.author
  const date = selectedTopic.publishedAt || selectedTopic.createdAt

  return (
    <div className='topic-banner_wrapper featuredBanner'>
      <a className='banner-notification_url' href={selectedTopic.url} />
      <div className='box banner-notification notification'>
        <div className='box__content box__pad'>
          <p className='notification-title'>
            <span className='notification-link'>
              {selectedTopic.title.length > 100 ? selectedTopic.title.substring(0, 100) + '...' : selectedTopic.title}
            </span>
          </p>
          {
            selectedTopic.startsAt
              ? (
                <span className='thread-meta-item__date notification-link'>
                  ({EventDateFormatter.formatStartAtForOverviewList(selectedTopic.startsAt)})
                </span>
                )
              : (
                <span className='thread-meta-item'>
                  {author || selectedTopic.post?.author
                    ? <UserAvatar
                        user={author || selectedTopic.post?.author}
                        extraClass='avatar avatar--S'
                        showRank
                      />
                    : null}
                  <span className='notification-link'>
                    <span className='thread-meta-item__date'>
                      {date
                        ? <DateRelative dateTime={new Date(date).getTime()} />
                        : selectedTopic.post?.relativeCreationDate || ''}
                    </span>
                  </span>
                </span>
                )
          }
        </div>
      </div>
    </div>
  )
}

export default TopicBanner
